var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ModuleNavLink col-4",class:[ { 'active': _vm.name == _vm.currNav } ],attrs:{"id":"NavLink"},on:{"click":_vm.clickOut}},[_c('span',[_vm._v(_vm._s(_vm.formattedName))])])}
var staticRenderFns = []

export { render, staticRenderFns }